// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2wTQD","amount":"Amount_amount__2vmED","tip":"Amount_tip__1BCF6","tipHeader":"Amount_tipHeader__20uao","tipsWrap":"Amount_tipsWrap__2hrIc"};